import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { Observable, switchMap, catchError, of } from "rxjs";
import {environment} from "../../environments/environment";
import {protectedResourceMap} from "../app.module";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  skipURI = [environment.trainOnTimeTrainsSuffix, environment.ActiveMessagesApiUrl]

  constructor(private msalService: MsalService ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    try {
      // Check if MSAL is initialized
      if (!this.msalService.instance) {
        return next.handle(req);
      }

      // Skip authentication for specified URIs
      const shouldSkip = this.skipURI.some(uri => req.url.includes(uri));
      if (shouldSkip) {
        return next.handle(req);
      }

      const activeAccount = this.msalService.instance.getActiveAccount();
      if (activeAccount) {
        const scope = this.getScope(req.url);
        if (scope) {
          return this.msalService.acquireTokenSilent({
            account: activeAccount, scopes: [scope]
          })
            .pipe(
              switchMap((authRequest) => {
                const clonedReq = req.clone({
                  headers: req.headers.set("Authorization",`Bearer ${authRequest.accessToken}`)
                });
                return next.handle(clonedReq);
              }),
              catchError(() => {
                // If token acquisition fails, continue without auth header
                return next.handle(req);
              })
            );
        }
      }
    } catch (error) {
      // If any MSAL error occurs, continue without authentication
      console.warn('MSAL error in interceptor, continuing without auth:', error);
    }
    
    return next.handle(req);
  }


  getScope(reqUrl: string) : string {
    let splitUrl: string[] 
    if (reqUrl.includes(environment.graphUrl)) {
      splitUrl = reqUrl.split("v1.0")
      return protectedResourceMap.get(splitUrl[0] + "v1.0")![0]
    } else{
        return "";
    }
  }
}
